
import events from 'events';
import $ from '@ali/tarzan-zepto';
import TPL from '../../../baseui/index';
import Field from './field/index';
import Voice from './voice/index';

require('./style.scss');

export default class Input extends events {

  constructor(config = {}) {
    super();

    this.$container = $(config.container);
    this.log = config.log;
    this.bridge = config.bridge;
    this.__current = null;
    // 只有手淘 手猫支持语音输入
    this.supportSpeech = false;
    const html = TPL.frame({ type: 'input', speech: this.supportSpeech });
    this.$container.append($(html));
    this.field = this.__initFiled();
    this.voice = this.__initVoice();
    this.__switch();
    this.__voiceInput();

    const useSpeech = config.inputType === 'voice' && this.supportSpeech;
    if (useSpeech) {
      this.useVoice();
    } else {
      this.useKeyboard();
    }
  }

  __initFiled() {
    const field = new Field({
      $container: this.$container,
      trigger: this.$container.find('.J_Field'),
    });

    const $btns = this.$container.find('.m-input-btn');
    field.on('resize', () => {
      this.emit('resize');
    });
    // 监听输入框内容变化
    field.on('input', (ev) => {
      if (ev.newVal) {
        $btns.addClass('active');
      } else {
        $btns.removeClass('active');
      }
    });

    return field;
  }

  __initVoice() {
    return new Voice({
      log: this.log,
      trigger: this.$container.find('.J_Voice'),
    });
  }

  /**
   * 语音输入
   * @private
   */
  __voiceInput() {
    this.voice.on('input', (input) => {
     // 若识别语音为空 不继续逻辑
      if (input.trim().length === 0) {
        this.emit('voicecancel');
        this.showTip();
      } else {
        this.emit('voice', input);
      }
    });
    // 开始语音输入
    this.voice.on('voicestart', () => {
      this.emit('voicestart');
    });
    // 取消语音输入
    this.voice.on('voicecancel', () => {
      this.emit('voicecancel');
    });
  }

  __switch() {
    const btn = this.$container.find('.J_BtnSwitch');
    const switchBtn = btn.find('.btn');
    btn.on('tap', () => {
      if (this.__current === 'voice') {
        switchBtn.attr('aria-label', '切换到键盘输入');
      } else {
        switchBtn.attr('aria-label', '切换到语音输入');
      }
      this.__switchInputType(this.__current);
    });
  }

  hideVoice() {
    const btn = this.$container.find('.J_BtnSwitch');
    btn.hide();
  }

  /**
   * 切换至键盘输入
   */
  useKeyboard() {
    this.__switchInputType('keyboard');
  }

  /**
   * 切换至语音输入
   */
  useVoice(force) {
    this.__switchInputType('voice', force);
  }

  /**
   * [__switchInputType description]
   * @param  {[type]} type  [description]
   * @param  {[type]} force 是否系统强制切换，是的话不埋点
   * @return {[type]}       [description]
   */
  __switchInputType(type, force) {
    const btn = this.$container.find('.J_BtnSwitch');
    const panel = this.$container.find('.J_Panel');

    const k = 'keyboard';
    const v = 'voice';

    if (type === k) {
      btn.removeClass(k).addClass(v);
      panel.removeClass(v).addClass(k);
      this.__current = v;
    } else if (type === v) {
      btn.removeClass(v).addClass(k);
      panel.removeClass(k).addClass(v);
      this.__current = k;
    }

    this.emit('switch', {
      inputType: type,
      force,
    });
  }

  showTip() {
    const $tipDom = $('<div class="m-voice-tip">\n</div>');

    $tipDom.appendTo('body');
    $tipDom.css({
      bottom: 60,
      left: ($(window).width() / 2) - 70,
    }).show();
    setTimeout(() => {
      $tipDom.remove();
    }, 1500);
  }

}



// WEBPACK FOOTER //
// ./src/component/view/footer/input/index.js